<template>
  <div class="app">
    <h1>{{ title }}</h1>
    <Header :activeIndex="'9'" />

    <main class="margintop">
      <nav class="tiaozhuan" aria-label="面包屑导航">
        <router-link to="/" style="cursor: pointer; color: inherit; text-decoration: none;">首页</router-link><span>&nbsp;&gt;&gt;&nbsp;</span><router-link
          to="/xueyuan" style="cursor: pointer; color: inherit; text-decoration: none;">老板学院</router-link><span>&nbsp;&gt;&gt;&nbsp;</span><span>知识详情</span>
      </nav>
      <div class="titlecss">{{ title }}</div>
      <article style="margin-left: auto; margin-right: auto">
        <div v-html="formattedContent" style="text-align: left"></div>
      </article>

      <div style="text-align: left" v-if="beforefont !== 'null' && beforefont !== null">
        关键词：{{ beforefont }}
      </div>

      <div style="text-align: left; margin-top: 0.7em">
        <span v-if="previousId != 'null' && previousId != 0" @click="fetchPathPreviousId(previousId)">上一篇：{{ previousTitle
        }}</span><br />
        <span v-if="nextId != 'null' && nextId != 0" @click="fetchPathNextId(nextId)">下一篇：{{ nextTitle }}</span><br />
        <span style="cursor: pointer" @click="pathIndex">返回首页</span>
      </div>
      <div style="text-align: left; margin-top: 0.7em" v-if="!isMobile">
        <span>分享</span>
        <img loading="lazy" id="shareImg" alt="分享页面二维码" />
      </div>

      <div style="margin-bottom: 50px"></div>
    </main>

    <Footer />
  </div>
</template>

<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import wx from "weixin-js-sdk";
export default {
  name: "xinwen",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      formattedContent: "",
      title: "",
      beforefont: "",
      image: "https://mingqicaiwu.com:9001/mingqi/thumbnail.jpg",
      id: 0,
      previousId: 0,
      previousTitle: "",
      nextId: 0,
      nextTitle: "",
      shareImg: "../assets/img/logo.jpg",
      shareDesc: "",
      shareImgdiyi: "",
      shareLink: "",
      isWeChat: false,
      appId: "wxea5602b03d0afffb",
      isMobile: true,

    };
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
    this.checkScreenSize(); // 初始化时检查屏幕大小
    window.addEventListener('resize', this.checkScreenSize);
    this.isWeChant = this.isWeChatBrowser();
  },
  created() {
    const id = this.$route.params.id || this.$route.query.id;
    this.id = id;
    this.fetchDataById(id);
    this.operationOne();
  },
  beforeDestroy() {
    this.removeFAQPageSchema();
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    removeFAQPageSchema() {
      const faqSchema = document.getElementById("faqpage-schema");
      if (faqSchema) {
        faqSchema.remove();
      }
    },

    stripHtml(html) {
      if (!html) return "";

      const div = document.createElement("div");
      div.innerHTML = html;

      return (div.textContent || div.innerText || "")
        .replace(/\s+/g, " ")
        .trim();
    },

    isFAQContent(title, content, beforefont) {
      const titleText = title || "";
      const contentText = this.stripHtml(content || "");
      const keywordText = beforefont || "";
      const allText = `${titleText} ${contentText} ${keywordText}`;

      // 标题或内容像问题
      const questionPattern = /[？?]|多少钱|多少费用|怎么收费|需要哪些|需要什么|需要多久|多久|几天|几个人|能不能|可以吗|能注册吗|怎么注册|怎么办理|如何办理|有哪些要求|有什么要求|需要到场吗|能代办吗|要交多少税|交多少税/;

      // 财税、工商、注册、代理记账相关关键词
      const businessPattern = /代理记账|注册公司|营业执照|注册地址|工商代办|工商变更|税务变更|公司注销|一般纳税人|小规模|开发票|法人|股东|报税|税收|税务|许可证|资质|商标注册|社保托管|高新|审计/;

      // 明显新闻类内容
      const articlePattern = /通知|公告|新闻|动态|资讯|政策解读|活动|发布|上线|升级|案例|行业|趋势|报告|提醒|名单|会议|培训|节日|放假/;

      if (articlePattern.test(titleText) && !/[？?]/.test(titleText)) {
        return false;
      }

      return questionPattern.test(allText) && businessPattern.test(allText);
    },

    addFAQPageSchema(title, content, id) {
      const answerText = this.stripHtml(content);

      if (!title || !answerText) {
        return;
      }

      this.removeFAQPageSchema();

      const pageUrl = `https://mingqicaiwu.com/news/${encodeURIComponent(id)}`;

      const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "@id": `${pageUrl}#faq`,
        "url": pageUrl,
        "mainEntity": [
          {
            "@type": "Question",
            "name": title,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": answerText
            }
          }
        ]
      };

      const script = document.createElement("script");
      script.id = "faqpage-schema";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    },

    handleFAQPageSchema(data, id) {
      this.removeFAQPageSchema();

      if (this.isFAQContent(data.title, data.content, data.beforefont)) {
        this.addFAQPageSchema(data.title, data.content, id);
      }
    },

    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // 根据屏幕宽度判断是否是移动端
    },
    isWeChatBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      return userAgent.indexOf("micromessenger") !== -1;
    },
    // operationTwo() {
    //   let shareDesc = ''
    //   if (this.formattedContent) {
    //     const text = this.formattedContent.replace(/<[^>]*>/g, '')
    //     shareDesc = text.substring(0, 20) + (text.length > 20 ? '...' : '')
    //   }

    //   // 分享图片
    //   let shareImg = ''
    //   if (this.formattedContent) {
    //     try {
    //       const parser = new DOMParser()
    //       const doc = parser.parseFromString(this.formattedContent, 'text/html')
    //       const img = doc.querySelector('img')
    //       if (img) shareImg = img.src
    //     } catch (e) {
    //       console.error('图片解析失败', e)
    //     }
    //   }

    //   // 分享链接
    //   const shareLink = window.location.href.split('#')[0]
    //   const sharetitle = this.title

    //   const data = new URLSearchParams();
    //   data.append("url", shareLink);

    //   fetch("https://mingqicaiwu.com:8201/admin/empuser/weixin/signature", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/x-www-form-urlencoded",
    //     },
    //     body: data,
    //   })
    //     .then((response) => response.json())
    //     .then((msg) => {
    //       wx.config({
    //         debug: false,
    //         appId: this.appId,
    //         timestamp: msg.timestamp,
    //         nonceStr: msg.nonceStr,
    //         signature: msg.signature,
    //         jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
    //       });

    //       var title = sharetitle;
    //       var share_desc = shareDesc;
    //       var img_url = shareImg;
    //       wx.ready(() => {
    //         console.log("ready方法执行");
    //         // alert("ready方法执行");
    //         //分享给微信好友
    //         wx.updateAppMessageShareData({
    //           title: title,
    //           desc: share_desc,
    //           link: shareLink,
    //           imgUrl: img_url,
    //           success: function () {
    //             // alert("updateAppMessageShareData执行成功");
    //             console.log("updateAppMessageShareData执行成功");
    //           },
    //           cancel: function(){
    //             console.error("分享取消！");
    //           }
    //         });

    //         wx.updateTimelineShareData({
    //           title: title, // 分享的标题
    //           link: shareLink, // 分享的链接
    //           imgUrl: img_url, // 分享的图标
    //           success: function () {
    //             console.log("分享成功！");
    //           },
    //           cancel: function () {
    //             console.error("分享取消！");
    //           },
    //         });
    //       });

    //       // 添加全局错误监听
    //       wx.error(function (res) {
    //         // alert("res:" + res.errMsg);
    //         console.log("res:", res);
    //       });
    //     })
    //     .catch((error) => console.error("请求失败:", error));
    // },
    operationTwo() {
      let shareDesc = this.formatDescription(this.formattedContent);
      // let shareImg = this.extractImageSrc(this.formattedContent);
      let shareImg = this.shareImg;
      const shareLink = window.location.href.split("#")[0];
      const shareTitle = this.title;

      const data = new URLSearchParams();
      data.append("url", shareLink);

      this.getWechatConfig(data)
        .then((msg) => {
          this.configureWx(msg, shareLink, shareTitle, shareDesc, shareImg);
        })
        .catch((error) => {
          console.error("请求失败:", error);
        });
    },

    // 提取文本描述，处理HTML标签
    formatDescription(content) {
      if (!content) return "";
      const text = content.replace(/<[^>]*>/g, "");
      return text.substring(0, 20) + (text.length > 20 ? "..." : "");
    },

    // 提取分享图片
    extractImageSrc(content) {
      if (!content) return "";
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, "text/html");
        const img = doc.querySelector("img");
        return img ? img.src : "";
      } catch (e) {
        console.error("图片解析失败", e);
        return "";
      }
    },

    // 获取微信配置
    getWechatConfig(data) {
      return fetch("https://mingqicaiwu.com:8201/admin/empuser/weixin/signature", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data,
      }).then((response) => response.json());
    },

    // 配置微信分享
    configureWx(msg, shareLink, shareTitle, shareDesc, shareImg) {
      wx.config({
        debug: false,
        appId: this.appId,
        timestamp: msg.timestamp,
        nonceStr: msg.nonceStr,
        signature: msg.signature,
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
      });

      wx.ready(() => {
        console.log("ready方法执行");

        // 分享给微信好友
        wx.updateAppMessageShareData({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          success: () => {
            console.log("updateAppMessageShareData执行成功");
          },
          cancel: () => {
            console.error("分享取消！");
          },
        });

        // 分享到朋友圈
        wx.updateTimelineShareData({
          title: shareTitle,
          link: shareLink,
          imgUrl: shareImg,
          success: () => {
            console.log("分享成功！");
          },
          cancel: () => {
            console.error("分享取消！");
          },
        });
      });

      // 全局错误监听
      wx.error(function (res) {
        console.log("res:", res);
      });
    },
    operationOne() {
      const data = new URLSearchParams();
      data.append("url", window.location.href.split("#")[0]);

      fetch("https://mingqicaiwu.com:8201/admin/code/generate", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data.toString(), // 转换为 URL 编码的形式
      })
        .then((response) => response.text()) // 使用 text() 而不是 json()
        .then((base64String) => {
          // 确保获取到 img 元素
          const shareImg = document.getElementById("shareImg");
          if (shareImg) {
            // 确保 base64String 以合适的格式开头
            shareImg.src = "data:image/png;base64," + base64String;
          } else {
            console.error("未找到 shareImg 元素");
          }
        })
        .catch((error) => {
          // alert("发生错误: " + error);
          console.log("操作错误", error);
        });
    },
    getDefaultTitle() {
      fetch("https://mingqicaiwu.com:8201/admin/news/selectById", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `id=${this.id}`,
      })
        .then((response) => response.json())
        .then((data) => {
          return data.title;
        })
        .catch((error) => {
          console.error("查询出错，原因是", error);
        });
    },
    fetchTwoId(id) {
      // 根据 id 查询数据的逻辑
      fetch("https://mingqicaiwu.com:8201/admin/news/getTwoId", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `id=${id}`,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.previousId != null) {
            this.previousId = data.previousId.id;
            this.previousTitle = data.previousId.title;
          }
          if (data.nextId != null) {
            this.nextId = data.nextId.id;
            this.nextTitle = data.nextId.title;
          }
          this.operationTwo();
        })
        .catch((error) => {
          console.error("查询出错，原因是", error);
        });
    },
    fetchPathPreviousId(id) {
      // 根据 id 查询数据的逻辑
      fetch("https://mingqicaiwu.com:8201/admin/news/getTwoId", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `id=${id}`,
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("前一页和后一页data",data);
          this.handleClick(id, data.nextId, data.previousId);
        })
        .catch((error) => {
          console.error("查询出错，原因是", error);
        });
    },
    handleClick(id) {
      const contentPageUrl = this.$router.resolve({ name: "news-detail", params: { id } }).href;

      window.location = contentPageUrl;
    },
    fetchPathNextId(id) {
      // 根据 id 查询数据的逻辑
      fetch("https://mingqicaiwu.com:8201/admin/news/getTwoId", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `id=${id}`,
      })
        .then((response) => response.json())
        .then((data) => {
          this.handleClick(id, data.nextId, data.previousId);
          // console.log("前一页和后一页data", data);
        })
        .catch((error) => {
          console.error("查询出错，原因是", error);
        });
    },
    fetchDataById(id) {
      // 根据 id 查询数据的逻辑
      fetch("https://mingqicaiwu.com:8201/admin/news/selectById", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `id=${id}`,
      })
        .then((response) => response.json())
        .then((data) => {
          document.title = data.title;
          this.title = data.title;
          this.formattedContent = data.content;
          this.beforefont = data.beforefont;

          this.handleFAQPageSchema(data, id);

          this.fetchTwoId(id);
        })
        .catch((error) => {
          console.error("查询出错，原因是", error);
          this.removeFAQPageSchema();
        });
    },
    pathIndex() {
      this.$router.push("/");
    },
    pathRemen() {
      this.$router.push("/remen");
    },
    pathCompanyReg() {
      this.$router.push("/zhuce");
    },
    pathJizhang() {
      this.$router.push("/jizhang");
    },
    pathgongshang() {
      this.$router.push("/gongshang");
    },
    pathshuiwu() {
      this.$router.push("/shuiwu");
    },
    pathzhichan() {
      this.$router.push("/zhichan");
    },
    pathxuke() {
      this.$router.push("/xuke");
    },
    pathrenshi() {
      this.$router.push("/renshi");
    },
    pathxueyuan() {
      this.$router.push("/xueyuan");
    },
    pathxinxi() {
      this.$router.push("/xinxi");
    },
    pathcontact() {
      this.$router.push("/contact");
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp;
    },
  },
};
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important;
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }
}
</style>

<style scoped>
/* 内容 */
.tiaozhuan {
  text-align: left;
  font-size: 18px;
  margin-bottom: 0.83em;
  font-weight: 500;
}

.margintop {
  margin-top: 118px;
  margin-left: 25%;
  margin-right: 25%;
}

.titlecss {
  font-size: 18px;
  font-weight: bold;
}

h1 {
  font-size: 0%;
}

h2 {
  font-size: 20px;
  font-weight: 400;
}

@media (max-width: 768px) {
  /* 其他 */

  .tiaozhuan {
    text-align: left;
    font-size: 11px;
  }

  .margintop {
    margin-top: 100px;
    margin-left: 2%;
    margin-right: 2%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xinwen.vue